// Imports:

// Styles:
import 'bootstrap/scss/bootstrap.scss'
import 'simplebar/dist/simplebar.css'

// Main.scss should always be last, otherwise your styles can be overwrite by styles from libraries
import '../scss/main.scss'

import lightbox from 'lightbox2/dist/js/lightbox.js'
import 'lightbox2/dist/css/lightbox.css'

let maxHeight = 700
if (window.innerWidth < 1439) {
  maxHeight = 600
}

lightbox.option({
  maxHeight: maxHeight,
})

import SimpleBar from 'simplebar'

// Common libraries:
import $ from 'jquery'
window.jQuery = $
window.$ = $

// Popper - neccessary for bootstrap
import Popper from 'popper.js/dist/umd/popper.js'
window.Popper = Popper

import 'bootstrap'

import { TweenMax, TimelineMax, AttrPlugin, CSSPlugin, Bounce } from 'gsap/all'

const activated = [TweenMax, TimelineMax, AttrPlugin, CSSPlugin, Bounce]

import ScrollMagic from 'scrollmagic'
window.ScrollMagic = ScrollMagic

import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap.js'

import 'imports-loader?define=>false!gsap/src/minified/plugins/ScrollToPlugin.min.js'

/* Scroll Magic Scens Plugin */
import Scens from './plugins/PluginScrollmagicScens.js'

const controller = new ScrollMagic.Controller()

window.scens = new Scens(controller)

// Plugins
import './plugins/PluginLoadDependecies'
import './plugins/PluginLazyLoad'
import './plugins/PluginOutline'
import './plugins/PluginBlockEmbed'
import './plugins/PluginAnalytics'
import cookiesController from './plugins/PluginCookies'
// Create CookiesController instance
window.CookiesController = cookiesController

import converSVG from './plugins/converSVG.js'

window.svg = new converSVG()
window.svg.converSVG()

import 'selectric/public/selectric.css'
import 'selectric/public/jquery.selectric.min.js'

const select = document.querySelector("[data-type='select']")

if (select) {
  $('select').selectric()
}

// Components:
import './components/ComponentPicker'
//

// Script to handle menuPages
// Handle show/hide of menu with all pages

// Get menu element
let BwMenuPages = $("[data-item='BW-navigation-menu']")

// Check if menu exists
if (BwMenuPages.length > 0) {
  // Show/hide on button with menu icon
  $("[data-item='BW-navigation-button']").on('click', () => {
    if (BwMenuPages.length > 0) {
      // Check if menu is visible
      if (BwMenuPages.hasClass('visible') !== true) {
        // If true -> animate show
        BwMenuPages.addClass('visible')
        BwMenuPages.animate({ opacity: '1' }, 300)
      } else {
        // If false -> animate hide
        BwMenuPages.animate({ opacity: '0' }, 300, function () {
          BwMenuPages.removeClass('visible')
        })
      }
    }
  })

  // Hide on button 'X" click
  $("[data-action='BW-navigation-hide']").on('click', () => {
    if (BwMenuPages.length > 0) {
      // Animate hide
      BwMenuPages.animate({ opacity: '0' }, 300, function () {
        BwMenuPages.removeClass('visible')
      })
    }
  })
}

// Init custom scrollbar
window.addEventListener('load', () => {
  initCustomScroll()
})

// Handle reinit on custom event
document.body.addEventListener('bw-custom-scroll-reload', () => {
  initCustomScroll()
})

function initCustomScroll() {
  // Find all elements where custom scroll should be initialized
  const scrollsContainers = document.querySelectorAll(
    `[data-custom-scroll='init']`
  )
  if (scrollsContainers.length > 0) {
    scrollsContainers.forEach((container) => {
      // Check if custom srcoll has ben alread init on this container
      if (container.getAttribute('data-custom-scroll-active') != 'true') {
        container.setAttribute('data-custom-scroll-active', 'true')

        new SimpleBar(container, { autoHide: false })
      }
    })
  }
}

// Remove preload class on load
window.addEventListener('load', () => {
  /* scroll magic scens */
  const animation = document.querySelector('[data-item="animation"]')

  if (animation) {
    window.scens.animation()
  }

  const foil_top = document.querySelector('[data-item="foil-top"]')

  if (foil_top) {
    setTimeout(() => {
      foil_top.classList.add('animation')
    }, 400)
  }

  setTimeout(function () {
    // Remove class that prevent transition
    const preload = document.querySelector('body')
    preload.classList.remove('preload')

    // hide loader
    let loader = document.querySelector("[data-item='loader']")
    let loaderStyle = document.querySelector("[data-item='loader-styles']")

    loader.parentNode.removeChild(loader)

    loaderStyle.parentNode.removeChild(loaderStyle)
  }, 100)

  /* Last word change */
  $("[data-item='last-word']").html(function () {
    var text = $(this).text().trim().split(' ')
    var last = text.pop()
    return (
      text.join(' ') + (text.length > 0 ? ' <span>' + last + '</span>' : last)
    )
  })

  /* First word change */
  $("[data-item='first-word']").html(function () {
    var text = $(this).text().trim().split(' ')
    var first = text.shift()
    return (
      (text.length > 0 ? '<span>' + first + '</span> ' : first) + text.join(' ')
    )
  })

  $('a.scroll').on('click', function (event) {
    // Make sure this.hash has a value before overriding default behavior
    if (this.hash !== '') {
      // Prevent default anchor click behavior
      event.preventDefault()

      // Store hash
      var hash = this.hash
      //console.log(hash);

      // Using jQuery's animate() method to add smooth page scroll
      // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
      $('html, body').animate(
        {
          scrollTop: $(hash).offset().top,
        },
        800,
        function () {
          // Add hash (#) to URL when done scrolling (default click behavior)
          window.location.hash = hash
        }
      )
    } // End if
  })

  /* Scroll if hash */
  if (window.location.hash) {
    var hash = window.location.hash
    let anchor = hash.split('#')

    let sectionAnchor = $('#' + anchor[1])

    if (sectionAnchor.length > 0) {
      $('html, body').animate(
        {
          scrollTop: $('#' + anchor[1]).offset().top - 100,
        },
        800
      )
    }
  }
})
